import React from "react";
import { CustomerData } from "../types/customerTypes";
import { IconButton, Tooltip, TablePagination } from "@mui/material";
import { Edit, DeleteOutline } from "@mui/icons-material";
import CommonTable, { HeadCell } from "../../../../../business-types/grocery/components/CommonTable";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "src/business-types/grocery/hooks/tableConfig";

type CustomerRow = {
  id: string;
  sno: number;
  Name: string;
  Email: string;
  phone_number: string;
  alternativenumber: string;
  Actions: JSX.Element;
};

interface CustomerTableProps {
  data: CustomerData[];
  page: number;
  rowsPerPage: number;
  totalRecords: number;
  showDeleted: boolean;
  onPageChange: (newPage: number) => void;
  onRowsPerPageChange: (newRowsPerPage: number) => void;
  onEdit: (customer: CustomerData) => void;
  onDelete: (id: string, name: string) => void;
}

const CustomerTable: React.FC<CustomerTableProps> = ({ data, page, rowsPerPage, totalRecords, showDeleted, onPageChange, onRowsPerPageChange, onEdit, onDelete,}) => {
  // Map raw data to rows for CommonTable
  const rows: CustomerRow[] = data.map((item, index) => ({
    id: item._id.$oid,
    sno: page * rowsPerPage + index + 1,
    Name: item.Name,
    Email: item.Email,
    phone_number: item.phone_number,
    alternativenumber: item.alternativenumber,
    Actions: (
      <>
        <Tooltip title="Edit" placement="bottom" arrow>
          <IconButton disabled={showDeleted} onClick={() => onEdit(item)}>
            <Edit style={{ color: showDeleted ? "gray" : "black" }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete" placement="bottom" arrow>
          <IconButton
            disabled={showDeleted}
            onClick={() => onDelete(item._id.$oid, item.Name)}
          >
            <DeleteOutline style={{ color: showDeleted ? "gray" : "red" }} />
          </IconButton>
        </Tooltip>
      </>
    ),
  }));

  const headCells: HeadCell<CustomerRow>[] = [
    { id: "sno", label: "S.No" },
    { id: "Name", label: "Customer Name" },
    { id: "Email", label: "Email ID" },
    { id: "phone_number", label: "Phone Number" },
    { id: "alternativenumber", label: "Alternative Phone" },
    { id: "Actions", label: "Actions", align: "center" },
  ];

  return (
    <div className="thin-scrollbar w-full overflow-y-auto">
      <CommonTable<CustomerRow>
        // key={rowsPerPage}
        data={rows}
        headCells={headCells}
        showToolbar={false}
        denseDefault={false}
        title="Customers"
        pageSize={rowsPerPage}
        pagenation={false}
        selectable={false}
      />

      <div className="flex justify-end mr-8 mt-2">
        <TablePagination
          component="div"
          count={totalRecords}
          page={page}
          onPageChange={(_, newPage) => onPageChange(newPage)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(e) => {
            const newSize = parseInt(e.target.value, 10);
            onRowsPerPageChange(newSize);
            onPageChange(0); // reset to first page
          }}
          rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
        />
      </div>
    </div>
  );
};

export default CustomerTable;
